<template>
  <div v-if="sent == false" class="signup">
    <h3>Signup by entering your email</h3>
    <input type="text" v-model="email" placeholder="Your Email">
    <button @click="signUp()">Sign Up</button>
  </div>
  <div v-else>
        <h3>Please check your inbox <3</h3>
  </div>
</template>

<script>
// @ is an alias to /src
import firebase from 'firebase'

export default {
  name: 'signup',
  data: function(){
    return{
      email:"",
      sent: false
    }
  },
  methods: {
    signUp: function(){
      firebase.auth().sendSignInLinkToEmail(this.email, {url: 'http://localhost:8081/verified', handleCodeInApp: true})
  .then(() => {
    localStorage.email = this.email;
    this.sent = true;
  }).catch((error) => {
    })

    }
  }
}
</script>
